import { render } from "./SectionProjects.vue?vue&type=template&id=2cc105a4&scoped=true"
import script from "./SectionProjects.vue?vue&type=script&lang=js"
export * from "./SectionProjects.vue?vue&type=script&lang=js"

import "./SectionProjects.vue?vue&type=style&index=0&id=2cc105a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc105a4"]])

export default __exports__